<section>
  <div>
    <h1>{{ client()?.clientDisplayName }} Configuration</h1>
  </div>
  <!-- @if(client !== null) -->
  @if(client() !== null && client() !== undefined)
  {
    <div>
      <app-client-info-view #clientInfoViewTab
        [client]="client()"
        [integration]="integration()"
        [integrations]="integrations()"
        [identifiers]="identifiers()"
        [clientIdentifiers]="clientIdentifiers()"
        [destinationEndpoints]="destinationEndpoints()"
        [(clientContracts)]="clientContracts"
      ></app-client-info-view>
    </div>
  }
</section>

@if(hasNoIntegrations)
{
  <div>
    <div><h3>This client has no integrations.</h3></div>
    <div class="d-flex flex-column m-2 align-center">
      <button matButton="elevated" (click)="goToAddIntegration()">Add Integration</button>
      <button matButton="elevated" [disabled]="savingInformation()" (click)="deleteClient()">Delete Client</button>
    </div>
  </div>
}

@if(integrations() !== null && integrations() !== undefined && integration() !== null && !hasNoIntegrations)
{
  <div>
    <div class="inline mb-3">
      <mat-button-toggle-group
        class="integration-toggle"
        [multiple]="false"
        [hideSingleSelectionIndicator]="true"
        (change)="selectNewIntegration($event.value)">
        <mat-button-toggle
          *ngFor="let i of integrations()"
          [value]="i"
          [checked]="i === integration()">
            {{ i.dataSourceTypeId}}-{{ i.name }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <mat-tab-group #tabstrip
      class="config-tabs lt-tabs mt-2"
      animationDuration="0ms"
      mat-align-tabs="center"
      [selectedIndex]="tabId"
      (selectedTabChange)="onTabSelect($event)">

      <mat-tab label="Configuration Information">
        <div class="edit-config-tab-content">
          @if(integrationSelected != false && serverList() !== null && serverList().length > 0)
          {
            <div class="mt-1">
              <app-integration-details-view #integrationDetails
                [integration]="integration()"
                [integrations]="integrations()"
                [servers]="serverList()"
                [identifiers]="identifiers()"
                [showIdentifiersComments]="getShowIdentifiersComments()"
                [savingInformation]="savingInformation()"
                (updateIntegration)="updateIntegration($event)"
              ></app-integration-details-view>

              <app-edit-integration-config #editConfigTab
                [client]="client()"
                [integration]="integration()"
                [destinationEndpoints]="destinationEndpoints()"
                [(savingInformation)]="savingInformation"
                (deleteIntegration)="handleDeleteIntegration($event)"
                (selectNewIntegration)="handleSelectNewIntegration($event)"
                (handleGoBack)="goBack()"
              ></app-edit-integration-config>
            </div>
          }
        </div>
      </mat-tab>

      @if(checkAccess(['LOSTalker.Integration']))
      {
        <mat-tab label="Integration Run Times">
            <div class="edit-config-tab-content">
              <app-integration-runtime [integration]="integration()" [destinationEndpoints]="destinationEndpoints()" #integrationRunTime></app-integration-runtime>
              <!-- <app-integration-runtime [integration]="integration" (runTimesPopulated)="setRunTimesPopulated($event)"
              #integrationRunTime></app-integration-runtime> -->
            </div>
        </mat-tab>

        <mat-tab label="Integration Push Backs">
            <div class="edit-config-tab-content">
              <app-integration-pushback [integration]="integration()" #integrationPushBack></app-integration-pushback>
            </div>
        </mat-tab>

        <mat-tab label="Integration Errors V3">
            <div class="edit-config-tab-content">
                <app-error-messages-v3 #errorListV3 id="errorListV3"
                    [integration]="integration()"
                    [currentClient]="client()"
                    [isInTab]="true">
                </app-error-messages-v3>
            </div>
        </mat-tab>
      }

      @if(checkAccess(['LOSTalker.DevOps']))
      {
        <mat-tab label="Revision History">
          <div class="edit-config-tab-content">
            <app-integration-revision [integration]="integration()" [client]="client()" [destinationEndpoints]="destinationEndpoints()" #revisionHistory
              (dataChanged)="updateFromHistory($event)">
            </app-integration-revision>
          </div>
        </mat-tab>
      }

      @if(checkAccess(['LOSTalker.Integration']))
      {
        <mat-tab label="Identifiers">
            <div class="edit-config-tab-content">
              <app-identifier-view #identifierTab [client]="client()" [integration]="integration()" [baseData]="identifiers()" [clientContracts]="clientContracts()"
                (identifier)="updateIntegrationIdentifier($event)" (deleteIdentifier)="deleteIntegrationIdentifier($event)">
              </app-identifier-view>
            </div>
        </mat-tab>
      }

      <mat-tab label="Process Data">
        <div class="edit-config-tab-content">
          <app-integration-process-view #processView
            [client]="client()"
            [integration]="integration()"
            [identifiers]="identifiers()"
            [integrationInfo]="integrationInfo"
            >
          </app-integration-process-view>
        </div>
      </mat-tab>

      @if(checkAccess(['LOSTalker.Integration']))
      {
        <mat-tab label="Failed Loans">
          <div class="edit-config-tab-content">
            <app-failed-loans-view [integration]="integration()" #failedLoanView></app-failed-loans-view>
          </div>
        </mat-tab>
      }

      @if(checkAccess(['LOSTalker.Admin']))
      {
        <mat-tab label="Custom SQL Queries">
          <div class="edit-config-tab-content">
            <app-sql-queries #queriesTab 
              [integration]="integration()"
              [client]="client()"
              [isInTab]="true">
            </app-sql-queries>
          </div>
        </mat-tab>
      }

    </mat-tab-group>

  </div>
}

@if((integrations() === null || integrations() === undefined ) && !hasNoIntegrations)
{
  <div class="loading-display">
    <app-lt-spinner></app-lt-spinner>
  </div>
}
